export default "__VITE_ASSET__Be_ehbFe__"